import React from "react";
import GibTahakkukPanel from "@/components/GibTahakkukPanel";
import { Landmark } from "lucide-react";

export default function GibIntegration() {
  return (
    <div className="space-y-5 fade-in">
      <div>
        <h1 className="font-head text-3xl font-semibold tracking-tight flex items-center gap-2"><Landmark size={26} /> GİB Entegrasyon</h1>
        <p className="text-sm text-muted-foreground mt-1">
          e-Beyanname · salt okunur beyanname/tahakkuk durumu. Veriler sizin başlattığınız çekimle (doğrulama koduyla) güncellenir.
        </p>
      </div>
      <GibTahakkukPanel />
    </div>
  );
}
